import { defineMessages } from 'react-intl';

export const markAsDSOModalMessages = defineMessages({
  title: {
    id: 'dsoModal.markTitle',
    defaultMessage: 'Mark as DSO',
  },
  content: {
    id: 'dsoModal.markDescription',
    defaultMessage: 'Are you sure you want to mark this organization as a DSO?',
  },
  success: {
    id: 'dsoModal.markSuccess',
    defaultMessage: 'Organization marked as DSO successfully',
  },
});

export const unmarkAsDSOModalMessages = defineMessages({
  title: {
    id: 'dsoModal.unmarkTitle',
    defaultMessage: 'Remove DSO Status',
  },
  content: {
    id: 'dsoModal.unmarkDescription',
    defaultMessage:
      'Are you sure you want to remove DSO status? This may affect client organizations.',
  },
  success: {
    id: 'dsoModal.unmarkSuccess',
    defaultMessage: 'DSO status removed successfully',
  },
});

export const parentDSOMessages = defineMessages({
  updateSuccess: {
    id: 'dsoModal.parentUpdateSuccess',
    defaultMessage: 'Parent DSO updated successfully',
  },
});

export const unmarkAsDistributorModalMessages = defineMessages({
  title: {
    id: 'distributorModal.unmarkTitle',
    defaultMessage: 'Remove Distributor Status',
  },
  content: {
    id: 'distributorModal.unmarkDescription',
    defaultMessage:
      'Are you sure you want to remove distributor status? This may affect client organizations.',
  },
  success: {
    id: 'distributorModal.unmarkSuccess',
    defaultMessage: 'Distributor status removed successfully',
  },
});
